import React from "react";
import LoadingButton from "../fields/LoadingButton";

function Modal(props) {
    return (
        <div class="actionModal modal fade" id="exampleDeleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleDeleteModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Confirm {props.msg} deletion</h5>
                    </div>

                    <div class="modal-body">
                        <p class="modal-msg">You are about to delete the {props.msg}</p>
                        <p><strong>Do you want to proceed?</strong></p>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>

                        {props.btnIsEnable ? (
                            <LoadingButton class_name={"sm-btn"} />
                        ) : (
                            <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={() => props.onDelete()}>
                                <span>
                                    {props.btnIsEnable ? "Loading..." : "Delete"}
                                </span>
                            </button>

                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal;